import type {
  AtlasNavigationResult,
  AtlasSearchProcess,
} from "@/lib/atlas/integration";

/** Short Atlas status for minimized nav bar (matches UltraNavigationBar). */
export function getAtlasStatusText(
  atlasProcess: AtlasSearchProcess | null,
  atlasNavigationResult: AtlasNavigationResult | null
): string {
  if (!atlasProcess) return "";
  switch (atlasProcess.status) {
    case "planning":
    case "navigating":
      return "Navigating";
    case "orienting":
      return "Orienting";
    case "ready":
    case "complete":
      if (atlasNavigationResult?.location?.topicName) {
        const location = atlasNavigationResult.location.topicName;
        return location.length > 24 ? `${location.substring(0, 21)}...` : location;
      }
      if (atlasNavigationResult?.orientation?.currentTopic) {
        const topic = atlasNavigationResult.orientation.currentTopic;
        return topic.length > 24 ? `${topic.substring(0, 21)}...` : topic;
      }
      return "Ready";
    default:
      return "Idle";
  }
}
